// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyDOfJ6gKKUO6kc8VjAB2un6x5PQKe5_NPg",
    authDomain: "cosmetic-72e64.firebaseapp.com",
    projectId: "cosmetic-72e64",
    storageBucket: "cosmetic-72e64.appspot.com",
    messagingSenderId: "1018443556483",
    appId: "1:1018443556483:web:2d04a0afd8e289812e9db6",
    measurementId: "G-LK5CJ6RDE4"
    // apiKey: "AIzaSyDOfJ6gKKUO6kc8VjAB2un6x5PQKe5_NPg",
    // authDomain: "cosmetic-72e64.firebaseapp.com",
    // projectId: "cosmetic-72e64",
    // storageBucket: "cosmetic-72e64.appspot.com",
    // messagingSenderId: "1018443556483",
    // appId: "1:1018443556483:web:08a09329df0704382e9db6",
    // measurementId: "G-N88KF444J6"
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
